/* eslint-disable react/no-danger */
import classNames from 'classnames';
import uniqBy from 'lodash/uniqBy';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Title from '../typography/Title';

import styles from '../../../styles/blocks/venues.module.css';

const propTypes = {
    layout: PropTypes.oneOf(['venues', 'regions']),
    title: PropTypes.string,
    query: PropTypes.shape({}),
    venues: PropTypes.arrayOf(PropTypes.shape({})),
    padded: PropTypes.bool,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

function SelectionBlock({
    layout = 'venues',
    title = null,
    query = null,
    venues = null,
    padded = false,
    className = null,
    isContainer = false,
    containerClassName = null,
}) {
    const { selection: queryVenues = null } = query || {};

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.padded]: padded,
                    [className]: className !== null,
                },
            ])}
        >
            <Title className={classNames([styles.section, styles.large, styles.title])}>
                {title || (
                    <FormattedMessage
                        defaultMessage="Participating venues"
                        description="Section title"
                    />
                )}
            </Title>
            <div
                id="venues"
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {layout === 'venues' && venues !== null && venues.length > 0
                    ? venues.map((venue) => {
                          const { id = null, name = null, url = null } = venue || {};
                          return url !== null ? (
                              <a
                                  className={styles.venue}
                                  href={url}
                                  key={`venue-${id}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                              >
                                  {name}
                              </a>
                          ) : (
                              <div key={`venue-${id}`} className={styles.venue}>
                                  {name}
                              </div>
                          );
                      })
                    : null}
            </div>
        </div>
    );
}

SelectionBlock.propTypes = propTypes;

export default SelectionBlock;
